import { PROCESS_STEPS } from "@/lib/siteData";

export const Process = () => {
  return (
    <section
      id="process"
      data-testid="process-section"
      className="relative py-24 sm:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 md:px-12">
        <div className="max-w-3xl mb-16">
          <div className="text-xs tracking-[0.25em] uppercase font-bold text-[#E3A21A] mb-4">
            Our Process
          </div>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight text-[#F5F5F0] font-medium">
            Four stages.{" "}
            <span className="text-[#A8B8A8]">One revenue system.</span>
          </h2>
        </div>

        <div className="relative">
          {/* Vertical / horizontal line */}
          <div className="hidden md:block absolute top-12 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#E3A21A]/30 to-transparent" />

          <div className="grid grid-cols-1 md:grid-cols-4 gap-6 md:gap-8">
            {PROCESS_STEPS.map((s, i) => (
              <div
                key={s.n}
                data-testid={`process-step-${i}`}
                className="relative group"
              >
                <div className="relative flex md:flex-col items-start gap-4 md:gap-0">
                  <div className="relative z-10 h-24 w-24 rounded-full bg-[#1E2A1E] border border-[#E3A21A]/25 flex items-center justify-center group-hover:bg-[#E3A21A] group-hover:border-[#E3A21A] transition-all duration-500 flex-shrink-0">
                    <span className="font-display text-3xl font-semibold text-[#E3A21A] group-hover:text-[#121A12] transition-colors">
                      {s.n}
                    </span>
                  </div>

                  <div className="md:mt-8">
                    <h3 className="font-display text-xl md:text-2xl text-[#F5F5F0] tracking-tight font-medium">
                      {s.title}
                    </h3>
                    <p className="mt-3 text-sm text-[#A8B8A8] leading-relaxed">
                      {s.desc}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
